/** Простой стор: состояние и подписчики. */
export interface Store<T> {
  get(): T;
  /** Заменить состояние целиком или функцией от прежнего. Тот же объект — подписчики не зовутся. */
  set(next: T | ((prev: T) => T)): void;
  /** Подписка на изменения; возвращает отписку. */
  subscribe(listener: (state: T, prev: T) => void): () => void;
}

export function createStore<T>(initial: T): Store<T> {
  let state = initial;
  const listeners = new Set<(s: T, p: T) => void>();
  return {
    get: () => state,
    set(next) {
      const prev = state;
      const value = typeof next === "function" ? (next as (p: T) => T)(prev) : next;
      if (Object.is(value, prev)) return;
      state = value;
      for (const l of [...listeners]) l(state, prev);
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
